export const DATE_FORMAT = 'MM/DD/YYYY';
export const DATE_FORMAT_WITH_TIME = 'MM/DD/YYYY LT';
export const DATE_FORMAT_WITH_TIME_LTS = 'MM/DD/YYYY LTS';
export const TIME_FORMAT = 'LT';
